import { render, staticRenderFns } from "./SetQuantity.vue?vue&type=template&id=3126fc5e"
import script from "./SetQuantity.vue?vue&type=script&lang=js"
export * from "./SetQuantity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports